import {BusinessInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class BusinessInfoModel {
  public currencyCode: string;

  constructor(params: BusinessInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string) {
    return new BusinessInfoModel({
      currencyCode,
    });
  }

  public static fromCartV2(businessInfo: BusinessInfo): BusinessInfoModel {
    return new BusinessInfoModel({
      currencyCode: businessInfo?.currencyCode,
    });
  }
}
